import * as React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    IconButton,
    useMediaQuery,
    useTheme,
    Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function YoutubeVedeoModal({ isOpenVedeoPlayer, setIsOpenVedeoPlayer, videoLink }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    console.log("videoLink", videoLink);

    const getEmbedLink = (url) => {
        const match = url?.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        return match ? `https://www.youtube.com/embed/${match[1]}` : '';
    };

    const embedLink = getEmbedLink(videoLink);



    return (
        <Dialog
            open={isOpenVedeoPlayer}
            onClose={() => setIsOpenVedeoPlayer(false)}
            fullWidth
            maxWidth="md"
            fullScreen={fullScreen}
            aria-labelledby="youtube-video-dialog"
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: 2,
                },
            }}
        >
            <DialogTitle
                sx={{
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '16px 24px',
                    borderBottom: '1px solid #e0e0e0',
                }}
            >
                YouTube Video
                <IconButton onClick={() => setIsOpenVedeoPlayer(false)}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ padding: 0 }}>
                <Box sx={{ width: '100%', height: { xs: 250, sm: 400 }, position: 'relative' }}>
                    <iframe
                        width="100%"
                        height="100%"
                        src={embedLink}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{ borderRadius: '0 0 8px 8px' }}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
}
